const formatOrderNumber = (ID, length = 6) => {
  const number = ID.toString();
  if (number.length >= length) {
    return number;
  }
  return new Array((length - number.length) + 1).join('0') + number;
};

export default formatOrderNumber;



// WEBPACK FOOTER //
// ./src/utils/formatOrderNumber.js